import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  constructor(
    private router: Router,
    private http: HttpClient,
  ) {}

  async registerNotifications(): Promise<void> {
    if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
      return;
    }
    if (!environment.vapidPublicKey) {
      return;
    }
    try {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') { return; }

      const registration = await navigator.serviceWorker.ready;
      const existing = await registration.pushManager.getSubscription();
      const subscription = existing ?? await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.urlBase64ToUint8Array(environment.vapidPublicKey)
      });

      localStorage.setItem('notificationToken', JSON.stringify(subscription));
    } catch (e) {
      console.warn('Push registration failed:', e);
    }
  }

  private urlBase64ToUint8Array(base64String: string): Uint8Array {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  addListeners(): void {
    // Web Push events are handled by the Angular service worker (ngsw-worker.js).
    // Deep-link on notification click can be wired via SwPush from @angular/service-worker.
  }
}
